import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import "../styles/resume.css";

const PdfViewer = ({ pdf }) => {
  useEffect(() => {
    // Google Analytics
    ReactGA.send({ hitType: "pageview", page: "/resume", title: "Resume" });
  }, []);

  return (
    <div className="pdf_viewer_container">
      <iframe src={pdf} className="pdf_viewer_frame" title="Resume"></iframe>
    </div>
  );
};

export default PdfViewer;
